import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { TrainingPage } from './pages/TrainingPage';
import { SocialsPage } from './pages/SocialsPage';
import { AboutPage } from './pages/AboutPage';
import { LeadCapturePage } from './pages/LeadCapturePage';
function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="flex flex-col min-h-screen bg-black font-sans text-white" data-id="element-2">
        <Header data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/training" element={<TrainingPage data-id="element-8" />} data-id="element-7" />
          <Route path="/socials" element={<SocialsPage data-id="element-10" />} data-id="element-9" />
          <Route path="/about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
          <Route path="/apply" element={<LeadCapturePage data-id="element-14" />} data-id="element-13" />
        </Routes>
        <Footer data-id="element-15" />
      </div>
    </Router>;
}
export { App };